import { ValidationSchemaParsed } from '../../../@types/validation-types'
import { ScreenName } from '../../domain/wizardScreens'
import { getRequiredFieldsPerScreen } from './getRequiredFieldsPerScreen'

export const getAllRequiredFields = (validationSchema: ValidationSchemaParsed): string[] => {
  let result = [] as string[]
  Object.entries(validationSchema).forEach((screenFieldsObject) => {
    result = result.concat(getRequiredFieldsPerScreen(validationSchema, screenFieldsObject[0] as ScreenName))
  })
  return result
}
